import { parseResponseText, parseEndpoint } from './utils';

interface Params {
  response: Pick<Response, 'status' | 'statusText' | 'url'>;
  responseText?: string | null;
  requestBody?: BodyInit | null;
}

export class BackendError extends Error {
  readonly responseUrl: string;

  readonly responseStatus: number;

  readonly responseText?: string | null;

  readonly requestBody?: BodyInit | null;

  readonly endpoint: string;

  readonly responseData: object | null;

  readonly searchParams?: Array<[key: string, value: string]>;

  constructor({ response, responseText, requestBody }: Params) {
    const { endpoint, searchParams } = parseEndpoint(response.url);

    super(`${endpoint}: [${response.status}] ${response.statusText}`);

    this.name = 'BackendError';
    this.endpoint = endpoint;
    this.searchParams = searchParams;
    this.responseUrl = response.url;
    this.responseStatus = response.status;
    this.responseText = responseText;
    this.requestBody = requestBody;
    this.responseData = parseResponseText(this.responseText);

    /**
     * Assigning for backward compatibility:
     *
     * api.get(url).catch(error => {
     *   // Before
     *   error // Object { code: 'unable_to_check_email', detail: 'Error checking email' }
     *
     *   // After
     *   error // BackendError { code: 'unable_to_check_email', detail: 'Error checking email', name,responseText,responseData,responseUrl,responseStatus }
     * })
     */
    Object.assign(this, this.responseData);
  }
}
